import { print } from 'graphql';
import { gql } from 'graphql-tag';
import type { MigrationStrategies, RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { getDateModified } from '../../utilities/utilityFunctions';
import { defaultDoc, getValueFromLocalStorage } from '../share/defaultDoc';

export interface PreviousReportFiles {
  readonly pkAssetInspection: string;
  readonly fkAsset: number;
  readonly site: number;
  readonly discipline: number;
  readonly originalPath: string;
  readonly inspectionType: string;
  readonly assetName: string;
  readonly dateCompleted: string;
  readonly dateCreated: string;
  readonly dateModified: string;
}

export const previousReportFilesSchema: RxJsonSchema<PreviousReportFiles> = {
  type: 'object',
  version: 1,
  description: 'describes work package files',
  primaryKey: 'pkAssetInspection',
  properties: {
    pkAssetInspection: { type: 'string', maxLength: 36 },
    fkAsset: { type: ['number', 'null'] },
    site: { type: ['number', 'null'] },
    discipline: { type: ['number', 'null'] },
    originalPath: { type: ['string', 'null'] },
    inspectionType: { type: ['string', 'null'] },
    assetName: { type: ['string', 'null'] },
    dateCompleted: { type: ['string', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
  },
};

export const previousReportFilesMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: PreviousReportFilesDocument) => {
    const newDoc = {
      ...oldDoc,
    };
    delete newDoc.inspectorId;
    return newDoc;
  },
};

export type PreviousReportFilesCollection = RxCollection<PreviousReportFiles> | null;
export type PreviousReportFilesDocument = RxDocument<PreviousReportFiles>;

export const previousReportFilesPullQueryBuilder = (document: PreviousReportFiles) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query assetInspectionReportFilesFeed(
      $siteId: Int!
      $disciplineId: Int!
      $lastModified: DateTime!
      $isLeadInspector: Boolean!
    ) {
      assetInspectionReportFilesFeed(
        siteId: $siteId
        disciplineId: $disciplineId
        lastModified: $lastModified
        isLeadInspector: $isLeadInspector
      ) {
        pkAssetInspection
        fkAsset
        site
        discipline
        originalPath
        inspectionType
        assetName
        dateCompleted
        dateCreated
        dateModified
      }
    }
  `);
  return {
    query,
    variables: {
      siteId: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      disciplineId: JSON.parse(getValueFromLocalStorage('selectedDiscipline'))
        ?.selectedDisciplineId,
      lastModified: getDateModified(
        doc?.dateModified,
        doc?.dateCreated,
        doc?.site,
        doc?.discipline,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      ),
      isLeadInspector: getValueFromLocalStorage('isLeadInspector') === 'True',
    },
  };
};

export default {};
